import React, { useMemo, useState } from "react"
import { Card, CardBody, Container, Button } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import VehicleContentSidebar from "./VehicleContentSidebar"
import VehicleStockPublishList from "./VehicleStockPublishList"
import { useListParams } from "hooks/useListParams"
import { useVehicleStockPublishes } from "hooks/useVehicleStockPublishes"

export default function PostStockList() {
  document.title = "Vehicle Content List"

  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const { data: counts } = useVehicleStockPublishes()
  const countsData = counts?.data?.count ?? []

  const { params, setPage, setSearch, updateParams } = useListParams({
    page: 1,
    search: "",
    slug: "bikroy",
    p_all: "all",
    brand: "",
    model: "",
    year: "",
    status: "",
    location: "",
    showroom: "",
    is_published: "",
    has_images: "",
    has_price: "",
    is_sold: "",
    price_min: "",
    price_max: "",
    sort_by: "created_at",
    sort_order: "desc",
  })

  const memoizedParams = useMemo(
    () => params,
    [
      params.page,
      params.search,
      params.slug,
      params.pending,
      params.p_modal,
      params.stock_id,
      params.p_page,
      params.p_all,
      params.brand,
      params.model,
      params.year,
      params.status,
      params.location,
      params.showroom,
      params.is_published,
      params.has_images,
      params.has_price,
      params.is_sold,
      params.price_min,
      params.price_max,
      params.sort_by,
      params.sort_order,
    ]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Content Manager"
            breadcrumbItem="Vehicle Content List"
          />

          {/* Mobile sidebar toggle — hidden on md+ */}
          <div className="d-md-none mb-3">
            <Button
              color="outline-secondary"
              size="sm"
              onClick={() => setIsSidebarOpen(prev => !prev)}
            >
              <i className="mdi mdi-view-list me-1" />
              {isSidebarOpen ? "Hide Platforms" : "Show Platforms"}
            </Button>
          </div>

          <div className="d-md-flex gap-3 align-items-start">
            <VehicleContentSidebar
              params={memoizedParams}
              updateParams={updateParams}
              data={countsData}
              isOpen={isSidebarOpen}
              onClose={() => setIsSidebarOpen(false)}
            />

            <div className="w-100 min-w-0">
              <Card>
                <CardBody>
                  <VehicleStockPublishList
                    params={memoizedParams}
                    updateParams={updateParams}
                    setPage={setPage}
                    setSearch={setSearch}
                    countsData={countsData}
                  />
                </CardBody>
              </Card>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}
